import { Attr, BelongsTo, Model } from "spraypaint";
import ApplicationRecord from "./ApplicationRecord";
import EmployerUser from "./EmployerUser";

@Model()
class JobNotificationRecipient extends ApplicationRecord {
  static jsonapiType = "job_notification_recipients";

  @Attr() jobId: number;

  @Attr() recipientId: number;

  @BelongsTo(EmployerUser) recipient: EmployerUser;
}

export default JobNotificationRecipient;
